<!--
  线下充值
  lovi 2020-1-10
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="routeData.title"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <template v-if="routeData.type == 8">
            <van-cell
              :title="$t('wallet.openingBank')"
              :value="routeData.bank.bank_name"
            />
            <van-cell
              :title="$t('wallet.accountNumber')"
              :value="routeData.bank.bank_username"
            />
            <van-cell :value="routeData.bank.card_number">
              <div slot="title">
                <span>{{ $t("wallet.bankCardNumber") }}</span>
                <i
                  class="icon-copy"
                  :data-clipboard-text="routeData.bank.card_number"
                  @click="copyText"
                ></i>
              </div>
            </van-cell>
          </template>
          <van-cell :title="$t('wallet.rechargeAmount')">
            <div slot="default">
              {{ routeData.money }}
              <template
                v-if="
                  routeData.type == 8 &&
                    (routeData.bank.country == 1 || routeData.bank.country == 3)
                "
              >
                / {{ exchange }}
                {{
                  routeData.bank.country == 1
                    ? "RMB"
                    : routeData.bank.country == 3
                    ? "VND"
                    : ""
                }}
              </template>
            </div>
          </van-cell>
          <van-cell :value="routeData.additional_code">
            <div slot="title">
              <span>{{ $t("wallet.additionalCode") }}</span>
              <i
                class="icon-copy"
                :data-clipboard-text="routeData.additional_code"
                @click="copyText"
              ></i>
            </div>
          </van-cell>
        </van-cell-group>
        <div class="button-wrap">
          <van-button block type="primary" @click="confirmFun">
            {{ $t("wallet.completePayment") }}
          </van-button>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <select-bank
        v-if="selectBankFlag"
        :selectBankFlag.sync="selectBankFlag"
        :data="routeData"
        @getBankData="getBankData"
      />
    </transition>

    <transition name="slide">
      <status
        v-if="statusFlag"
        :statusFlag.sync="statusFlag"
        :data="routeData"
      />
    </transition>
  </div>
</template>

<script>
import _ from "lodash";
import Clipboard from "clipboard";
import SelectBank from "./selectBank";
import Status from "./status";
export default {
  name: "rechargeOffline",
  components: { Status, SelectBank },
  data() {
    return {
      routeData: {}, // 路由数据
      selectBankFlag: false,
      statusFlag: false,
      exchange: 0
    };
  },
  created() {
    let vm = this;
    if (_.isEmpty(vm.$route.params)) {
      // 刷新页面要返回
      vm._back();
    } else {
      vm.routeData = vm.$route.params;
      if (vm.routeData.type == 8) {
        // 线下银行卡
        vm.selectBankFlag = vm.routeData.selectBank ? true : false;
        vm.exchange = vm._PHPtoRMB(
          parseFloat(vm.routeData.money),
          parseFloat(vm.routeData.bank.exchange_rate)
        );
      }
      console.log("routeData5454", vm.routeData);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    copyText() {
      var clipboard = new Clipboard(".icon-copy");
      clipboard.on("success", e => {
        console.info("Action:", e.action);
        this.$toast(this.$t("common.copySuccess"));
        clipboard.destroy(); // 释放内存
      });
      clipboard.on("error", e => {
        console.info("error:", e.action);
        this.$toast(this.$t("common.browserNoCopy"));
        clipboard.destroy(); // 释放内存
      });
    },
    getBankData(data) {
      // 获取银行卡信息
      let vm = this;
      console.log("getBankData", data);
      vm.routeData.additional_code = data.additional_code;
      vm.routeData.money = data.money;
      vm.routeData.bank.bank_id = data.bank_id;
      vm.routeData.bank.bank_name = data.bank_name;
      vm.routeData.bank.bank_username = data.bank_username;
      vm.routeData.bank.card_number = data.card_number;
      vm.routeData.bank.country = data.country;
      vm.routeData.bank.exchange_rate = data.exchange_rate;
      vm.exchange = vm._PHPtoRMB(
        parseFloat(vm.routeData.money),
        parseFloat(vm.routeData.bank.exchange_rate)
      );
      vm.routeData.exchange = vm.exchange;
    },
    confirmFun() {
      // 确认
      let vm = this;
      vm.$post(
        "/app/pay/complete_pay",
        { code: vm.routeData.additional_code },
        { loading: true }
      ).then(res => {
        console.log("complete_pay", res);
        vm.statusFlag = true;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  .van-cell__title {
    flex: initial;
    margin-right: 10px;
    div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        background: url("~@/assets/images/public/icon_copy@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
